import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var ThrottleType = /** @class */ (function (_super) {
    __extends(ThrottleType, _super);
    function ThrottleType() {
        return _super.call(this) || this;
    }
    ThrottleType.classInitializer = null;
    ThrottleType.classSymbols = null;
    ThrottleType.instanceSymbols = null;
    // JS -> AS Bindings
    ThrottleType.THROTTLE = 'throttle';
    ThrottleType.PAUSE = 'pause';
    ThrottleType.RESUME = 'resume';
    return ThrottleType;
}(ASObject));
export { ThrottleType };
